import { Box, Divider, Stack, styled } from "@mui/material";
import { ReactComponent as Avatar } from "images/avatar.svg";
import {
  AvatarHolder,
  EndIcon,
  IconHolder,
  Level,
  LevelColorSx,
  LevelScaleColorSx,
  LevelScaleFontColorSx,
  ProgressBase,
  ProgressLevel,
  StartIcon,
  UserName,
} from "../Dashboard.style";
import { mobileModes } from "../Dashboard";
import { GoBack } from "UI/GoBack";
import {
  STARTER_MAX_PROGRESS,
  BRONZE_MAX_PROGRESS,
  SILVER_MAX_PROGRESS,
  GOLD_MAX_PROGRESS,
} from "../Dashboard";
import RewardBronze from "../images/reward-bronze.svg";
import RewardGold from "../images/reward-gold.svg";
import RewardPlatinum from "../images/reward-platinum.svg";
import RewardSilver from "../images/reward-silver.svg";
import RewardStarter from "../images/reward-starter.svg";
import StarIcon from "../images/star.svg";
import clsx from "clsx";
import { Link } from "react-router-dom";
import { ReactComponent as LogoIcon } from "../images/rs-icon.svg";
import { ReactComponent as SignupIcon } from "../images/signup-icon.svg";
import { guideSteps } from "hooks/useOnboarding";

const MAX_DISPLAY_SCALE_LEVEL_IN_PERC = 90;
const REFERRALS_IN_LEVEL = 50;

const Score = styled(Stack)`
  /* font-size: 13px;
  font-weight: 600;
  line-height: 16px;
  letter-spacing: 0.02477119117975235px;
  text-align: left; */

  position: absolute;
  width: 239px;
  height: 29px;

  font-size: 15px;
  font-weight: 600;
  line-height: 18px;
  letter-spacing: 0.02477119117975235px;
  text-align: left;
`;

export const Profile = ({
  progress,
  userLevel,
  originator,
  levelProgress,
  asPage = false,
  setMode = () => null,
  isRecipientAdmin,
}) => {
  return (
    <div
      className="
        relative
        grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-1 2xl:grid-cols-1
        gap-2 px-4 h-fit xl:w-[300px]"
    >
      {asPage && (
        <GoBack
          hanldeClick={() => setMode(mobileModes.Dashboard)}
          label="Account"
        />
      )}
      <div
        className={clsx(
          guideSteps.PROFILE,
          "flex flex-col justify-between items-center mb-1 place-self-center",
          "rounded-xl bg-white p-4 pb-1"
        )}
        style={{ background: "linear-gradient(#007AFF 99px, white 99px)" }}
      >
        <AvatarHolder
          // @ts-ignore
          value={progress}
          levelcolor={LevelColorSx[userLevel]}
        >
          <Avatar />
        </AvatarHolder>
        <UserName>
          {originator?.firstName} {originator?.lastName}
        </UserName>
        <Level
          // @ts-ignore
          sx={{ color: LevelColorSx[userLevel] }}
        >
          {userLevel}
        </Level>
        {levelProgress <= MAX_DISPLAY_SCALE_LEVEL_IN_PERC && (
          <Box sx={{ position: "relative" }}>
            <Score
              alignItems={"center"}
              justifyContent={"center"}
              sx={{
                color: LevelScaleFontColorSx[userLevel],
              }}
            >
              {Math.round((levelProgress / 100) * REFERRALS_IN_LEVEL)} /{" "}
              {REFERRALS_IN_LEVEL} referrals
            </Score>
            <ProgressBase sx={{ backgroundColor: "#EFEFEF" }}>
              <ProgressLevel
                sx={{
                  width: `${levelProgress < 20 ? 20 : levelProgress}%`,
                  minWidth: "fit-content",
                  color: LevelScaleFontColorSx[userLevel],
                  backgroundColor: LevelScaleColorSx[userLevel],
                }}
              >
                {StartIcon[userLevel]}
              </ProgressLevel>
              {EndIcon[userLevel]}
            </ProgressBase>
          </Box>
        )}
        {levelProgress > MAX_DISPLAY_SCALE_LEVEL_IN_PERC && (
          <ProgressLevel
            width={"239px"}
            sx={{
              color: LevelScaleFontColorSx[userLevel],
              backgroundColor: LevelScaleColorSx[userLevel],
            }}
          >
            {StartIcon[userLevel]}
            {Math.round((levelProgress / 100) * REFERRALS_IN_LEVEL)} /{" "}
            {REFERRALS_IN_LEVEL} referrals
            <IconHolder>{EndIcon[userLevel]}</IconHolder>
          </ProgressLevel>
        )}
      </div>
      <div className="md:hidden lg:hidden xl:hidden 2xl:hidden flex flex-col justify-center items-center">
        <button
          onClick={() => setMode(mobileModes.Awards)}
          className="bg-black mt-0 w-60 text-white font-bold py-2 px-2 rounded-xl hover:bg-gray-800"
        >
          View My Rewards
        </button>
      </div>
      <div className="flex flex-col flex-grow justify-between lg:justify-center items-center w-full">
        <div className="flex flex-col justify-start items-start gap-1 w-full max-w-xs">
          <div className="flex flex-row flex-wrap items-start justify-start gap-1">
            <div className="text-gray-400 text-sm">Job Title:</div>
            <div className="text-sm">{originator?.jobTitle}</div>
          </div>
          <Divider orientation="horizontal" flexItem />
          <div className="flex flex-row flex-wrap items-start justify-start gap-1">
            <div className="text-gray-400 text-sm">Practice:</div>
            <div className="text-sm">{originator?.practiceName}</div>
          </div>
          <Divider orientation="horizontal" flexItem />
          <div className="flex flex-row flex-wrap items-start justify-start gap-1">
            <div className="text-gray-400 text-sm">Phone:</div>
            <div className="text-sm text-wrap break-all">
              {originator?.phone}
            </div>
          </div>
          <Divider orientation="horizontal" flexItem />
          <div className="flex flex-row flex-wrap items-center justify-start gap-1">
            <div className="text-gray-400 text-sm">Email:</div>
            <div className="text-xs text-wrap break-all">
              {originator?.email}
            </div>
          </div>
        </div>
        <div className="mt-6 flex flex-col gap-1 w-full max-w-xs">
          <Link
            to="https://referral-stream.webflow.io"
            target="_blank"
            className={clsx("mt-1", guideSteps.WEBSITE)}
          >
            <div
              className={clsx(
                "bg-gray-100 p-2 flex flex-row justify-start items-start rounded-xl cursor-pointer gap-1"
              )}
            >
              <LogoIcon />
              <div className="flex flex-col gap-1">
                <div className="text-sm font-bold text-black">
                  Referral Stream’s Website
                </div>
                <div className="text-xs text-gray-500">
                  Learn more about Referral Stream
                </div>
              </div>
            </div>
          </Link>
          {!isRecipientAdmin && (
            <Link
              to="https://app.referral-stream.com/sign_up/recipient"
              target="_blank"
              className={clsx("mt-1", guideSteps.WEBSITE)}
            >
              <div className="bg-gray-100 p-2 flex flex-row justify-start items-start rounded-xl cursor-pointer gap-1">
                <SignupIcon />
                <div className="flex flex-col gap-1">
                  <div className="text-sm font-bold text-black">
                    Sign up as a Recipient
                  </div>
                  <div className="text-xs text-gray-500">
                    Start receiving referrals
                  </div>
                </div>
              </div>
            </Link>
          )}
        </div>
      </div>
      <div className="flex flex-col justify-between items-stretch">
        <div
          className={clsx(
            "bg-gray-100 rounded-xl px-10 py-4 mb-4 flex-1",
            "hidden lg:flex xl:hidden flex-wrap flex-row gap-4 justify-between items-center"
          )}
        >
          <div className="text-lg text-gray-600">
            <div className="flex flex-row items-center gap-2 text-lg font-bold text-black">
              <img src={StarIcon} alt="star icon" className="w-6" />
              My Rewards
            </div>
            <div className="lg: text-sm">
              Your progress is displayed here, keep it up!
            </div>
          </div>
          <div className="flex flex-row flex-wrap items-center gap-4 text-lg font-bold text-black">
            <img src={RewardStarter} alt="reward starter" className="w-14" />
            {progress > STARTER_MAX_PROGRESS && (
              <img src={RewardBronze} alt="reward bronze" className="w-14" />
            )}
            {progress > BRONZE_MAX_PROGRESS && (
              <img src={RewardSilver} alt="reward silver" className="w-14" />
            )}
            {progress > SILVER_MAX_PROGRESS && (
              <img src={RewardGold} alt="reward gold" className="w-14" />
            )}
            {progress > GOLD_MAX_PROGRESS && (
              <img
                src={RewardPlatinum}
                alt="reward platinum"
                className="w-14"
              />
            )}
          </div>
        </div>
        <div className="text-xs flex flex-row justify-center items-center gap-1">
          <Link
            className="text-blue-600"
            to="https://referral-stream.webflow.io/terms-of-service"
          >
            Terms of Service
          </Link>
          &
          <Link
            className="text-blue-600"
            to="https://referral-stream.webflow.io/privacy-policy"
          >
            Privacy Policy
          </Link>
        </div>
      </div>
    </div>
  );
};
